export default "__VITE_ASSET__kqOEKLh2__"